export default {
      id: "icon-x-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-x",
      toString: function () {
        return this.url;
      }
    }